<template>
	<div>
		<div v-show="Bond">
			<div style="font-size:20px;float:left;margin:-35px 0 0 40px;font-weight:600">保证金管理</div>
			<div style="height:780px;background-color:white;margin:75px 40px 0 40px">

				<div style="margin-left:3%">
					<div style="height:30px"></div>
					<span style="margin-right:10px;margin-left:10px">公司名头</span>
					<el-select v-model="condition.partner_id" placeholder="请选择" clearable>
						<el-option v-for="item in partnerList" :key="item.id" :label="item.partner_abbreviation"
							:value="item.id">
						</el-option>
					</el-select>
					<span style="margin-right:10px">组织架构</span>
					<el-cascader v-model="organizeIds_num" @change="changeCascader" clearable
						style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>

					<span style="margin-right:10px;margin-left:10px">项目名称</span>
					<el-input class="input" v-model="condition.project_name" placeholder=""></el-input>
					<span style="margin-right:10px;margin-left:10px">申请人</span>
					<el-input class="input" v-model="condition.applicantName" placeholder=""></el-input>
					<br>
					<div class="rz">
						<span style="margin-right:10px;margin-left:10px">付款时间</span>
						<el-date-picker style="width:25%" v-model="condition.start_date" type="daterange"
							range-separator="至" start-placeholder="开始日期" format="yyyy-MM-dd" end-placeholder="结束日期"
							value-format="yyyy-MM-dd">
						</el-date-picker>
						<!-- <span style="margin-right:10px;margin-left:10px">回款状态</span>
						<el-select style="margin-right:10px" v-model="condition.is_formal" placeholder="全部" clearable>
							<el-option v-for="item in ztList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select> -->
						<el-button style="width:85px;height:41px" type="goon" @click="Find">查询</el-button>
						<el-button style="width:85px;height:41px" type="goon" @click="Add">新增</el-button>
						<div style="display:inline-block;margin-left:190px">
							<download-excel class="export-excel-wrapper" :fields="download_excel" title="转正人员清单"
								name="转正人员清单.xls" :fetch="ExportForm" style="margin-left:-180px;top:100px">
								<el-button type="goon"
									style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
									导出</el-button>
							</download-excel>
						</div>

					</div>

				</div>

				<div style="margin:3% 2% 0 2%">
					<el-table ref="multipleTable" :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:data="tableData" tooltip-effect="dark" style="width: 100%" height="530"
						@selection-change="handleSelectionChange">
						<!-- <el-table-column type="selection" width="55"> </el-table-column> -->
						<el-table-column label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column prop="partnerNmame" label="公司名头" align="center">
						</el-table-column>
						<el-table-column align="center" label="组织架构" width="300">
							<template slot-scope="scope">
								{{$globals.group_name + "/" + scope.row.organizeName}}
							</template>
						</el-table-column>

						<el-table-column prop="project_name" label="项目名称" align="center">
						</el-table-column>
						<el-table-column prop="money_amount" label="金额" align="center">
						</el-table-column>
						<el-table-column prop="applicantName" label="申请人" align="center">
						</el-table-column>
						<el-table-column prop="approval_director" label="审批总监" align="center">
						</el-table-column>
						<el-table-column prop="estimate_payment_time" label="预计付款时间" align="center" width="120">
						</el-table-column>
						<el-table-column prop="payment_time" label="付款时间" align="center">
						</el-table-column>
						<el-table-column prop="" label="付款凭证" align="center" width="100">
							<template slot-scope="scope">
								<img src="../../../assets/查看.png" @click="Voucher(scope.row.id)" />
							</template>
						</el-table-column>
						<el-table-column prop="uncollected_payment" label="未回款金额" align="center" width="100">
						</el-table-column>
						<el-table-column prop="spare" label="备注" align="center">
						</el-table-column>
						<el-table-column prop="modified_time" label="最后操作时间" align="center" width="120">
						</el-table-column>
						<el-table-column prop="status" label="状态" align="center" fixed="right" width="100">
							<template slot-scope="scope">
								<img src="../../../assets/stateImg/状态_未生效.png" v-show="scope.row.status === '0' " />
								<img src="../../../assets/stateImg/状态_已生效.png" v-show="scope.row.status === '1' " />
							</template>
						</el-table-column>
						<el-table-column label="当前节点" align="center" fixed="right" width="120">
							<template slot-scope="scope">
								<div style="color: #006E4B;text-decoration: underline;" @click="panelPoint(scope.row)">
									<span>节点A</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" fixed="right" width="200">
							<template slot-scope="scope">
								<img src="../../../assets/icon/回款管理.png" @click="Manage(scope.row.id)" />
								<img src="../../../assets/icon/付款登记及修改.png" @click="Update(scope.row)" />
								<img src="../../../assets/icon/修改.png" @click="Revise(scope.row)" />
								<img src="../../../assets/icon/删除.png" @click="Del(scope.row.id)" />
							</template>
						</el-table-column>
					</el-table>
					<!-- 分页 -->
					<el-row style=" margin-left: 500px;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</div>
			</div>
			<el-dialog :title="ruleForm.id == null || ruleForm.id == '' ? '新增' : '修改'" :visible.sync="showadd"
				width="30%" center="true" :close-on-click-modal="false">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
					<el-row>
						<el-col :span="12">
							<el-form-item label="公司名头" prop="dictionaries_id" style="margin-top:0px;">
								<el-select v-model="ruleForm.partner_id" placeholder="请选择" clearable
									style="width:360px">
									<el-option v-for="item in partnerList" :key="item.id"
										:label="item.partner_abbreviation" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="组织架构" prop="project_id"
								v-if="ruleForm.id == null || ruleForm.id == ''">
								<el-cascader v-model="organize_id" @change="changeCascader" style="width:360px"
									collapse-tags :props="props">
								</el-cascader>
							</el-form-item>
							<el-form-item label="组织架构" prop="project_id" v-else>
								<div
									style="border:1px solid #DCDFE6; width:340px;border-radius:5px;padding-left:10px;padding-right:10px">
									{{$globals.group_name + "/" + ruleForm.organizeName}}
								</div>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="项目名称">
								<el-input v-model="ruleForm.project_name" style="width:360px">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="金额" prop="money_amount">
								<el-input v-model="ruleForm.money_amount" style="width:360px">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="预计付款日期" prop="reason">
								<el-date-picker value-format="yyyy-MM-dd" v-model="ruleForm.estimate_payment_time"
									type="date" style="width:360px" placeholder="选择日期">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="备注" prop="money">
								<el-input v-model="ruleForm.spare" placeholder="请输入备注" style="width:360px"></el-input>
							</el-form-item>
						</el-col>
					</el-row>


					<el-form-item style="margin: 0  100px;">
						<el-button type="goon" @click="AddSave()" v-if="ruleForm.id == null || ruleForm.id == ''">保存
						</el-button>
						<el-button type="goon" @click="ReviseSave()" v-else>修改</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
			<el-dialog title="审核" :visible.sync="spShow" width="35%" center="true" :close-on-click-modal="false">
				<div style="width: 100%;">
					<div>审核名称：保证金审核</div>
					<el-table ref="multipleTable" :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:data="tableDataList.examineDetailsList" tooltip-effect="dark" style="width: 100%" height="300"
						@selection-change="handleSelectionChange">
						<el-table-column label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column prop="node" label="节点" align="center">
						</el-table-column>
						<el-table-column prop="role_name" label="岗位" align="center">
						</el-table-column>
						<el-table-column prop="staff_name" label="审核人" align="center">
						</el-table-column>
					</el-table>
					<div style="text-align: center;margin-top: 10px;">
						<el-button type="goon" @click="AddSavesp()">确定</el-button>
					</div>
				</div>
				<div style="height: 30px;"></div>
			</el-dialog>
			<el-dialog title="选择姓名" :visible.sync="dialogVisible" width="40%" center="true"
				:close-on-click-modal="false" :show-close="false" :modal-append-to-body="false">
				<el-row>
					<organizeStaff ref="organizeStaff" type="radio" :accordion="false" @commit="saveChange"
						:staff_id_prop="ruleForm.staff_id"></organizeStaff>
				</el-row>
				<el-row style="text-align: center;">
					<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定
					</el-button>
				</el-row>
			</el-dialog>

			<el-dialog title="查看审批流程" :visible.sync="showPoint" width="25%" center="true" :close-on-click-modal="false">
				<div v-for="(item, index) in approveList" :key="index">
					<div class="approve">
						<div class="approve-left">
							<img src="../../../assets/oa/flowPath-green.png" alt="" class="approve-img"
								v-if="item.reviewer_state == 1">
							<img src="../../../assets/oa/flowPath-red.png" alt="" class="approve-img"
								v-if="item.reviewer_state == 2">
							<img src="../../../assets/oa/flowPath-orange.png" alt="" class="approve-img"
								v-if="item.reviewer_state == 0">
						</div>
						<div class="position">
							<div class="position-left">
								<div>{{ item.staff_name }}</div>
								<div
									:class="item.reviewer_state == 0 ? 'orange' : item.reviewer_state == 1 ? 'green' : item.reviewer_state == 2 ? 'red' : 'blue'">
									<span v-if="item.reviewer_state == 1">已同意</span>
									<span v-if="item.reviewer_state == 2">已驳回</span>
									<span v-if="item.reviewer_state == 0">待审批</span>
								</div>
								<div class="position-refuse" v-if="item.reviewer_state == 2">
									驳回原因：{{ item.reject_reason }}
								</div>
							</div>
							<div class="position-time" v-if="item.reviewer_state != 0">{{ item.reviewer_date }}</div>
						</div>
					</div>
					<div class="approve-hr" v-if="index != approveList.length - 1"></div>
				</div>
			</el-dialog>
			<!-- 付款凭证 -->
			<el-dialog title="" :visible.sync="showVoucher" width="30%" center="true" :close-on-click-modal="false">
				<div style="width: 100%;" v-for="item in VoucherList.photoList">
					<img :src="item.honour_photo" style="width: 100%;height: 300px;" />
					<div style="float: right;margin-top: 10px;margin-bottom: 20px;">
						<img src="../../../assets/小下载.png" style="vertical-align: middle;" />
						<span style="color: #006E4B;font-size: 16px;">下载</span>
					</div>
				</div>
				<div style="height: 30px;"></div>
			</el-dialog>

			<el-dialog title="付款登记及修改" :visible.sync="showUpdate" width="30%" center="true"
				:close-on-click-modal="false">
				<div>
					<el-form label-position="right" label-width="80px" :model="formLabelAlign">
						<el-form-item label="付款时间">
							<el-date-picker style="width: 100%;" v-model="updatePhoto.payment_time" type="datetime"
								format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="付款凭证">
							<el-upload :action="$globals.http + '/file/upload'" list-type="picture-card"
								:on-preview="handlePictureCardPreview" :on-remove="handleRemove"
								:before-remove="beforeremove" :on-success="handleAvatarSuccess" :file-list="photoList">
								<i class="el-icon-plus"></i>
							</el-upload>
							<el-dialog :visible.sync="dialogVisibles">
								<img width="100%" :src="photoList" alt="">
							</el-dialog>
						</el-form-item>
						<el-form-item style="margin: 0  100px;">
							<el-button type="goon" @click="AddSavePhoto()">保存
							</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-dialog>
		</div>
		<manage ref="manages" v-if="showManage" :projectList="projectList" :conditions="conditions" @close="closeManage"
			:manageList="manageList"></manage>
	</div>
</template>

<script>
	import axios from 'axios';
	// import add from './add.vue';
	import point from './point.vue';
	import manage from './manage.vue';
	import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
	export default {
		components: {
			// add: add,
			point: point,
			manage: manage,
			organizeStaff: organizeStaff,
		},
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {

				total: 0,
				Bond: true,
				showadd: false,
				showVoucher: false,
				showPoint: false,
				showUpdate: false,
				showManage: false,
				centerDialogVisible: false,
				dialogVisibles: false,
				spShow: false,
				projectList: [],
				dialogImageUrl: '',
				Vouchers: '',
				//状态数据
				ztList: [{
					value: '0',
					label: '未生效'
				}, {
					value: '1',
					label: '已生效'
				}],
				updatePhoto: {
					id: '',
					payment_time: '',
					photoList: [],
				},
				//表单数据
				ruleForm: {
					partner_id: '',
					organize_id: '',
					project_name: '',
					money_amount: '',
					estimate_payment_time: '',
					spare: '',
					id: '',
					applicant_id: '',
				},
				//条件
				condition: {
					page_num: 1,
					page_size: 10,
					partner_id: '',
					organize_ids: '',
					project_name: '',
					applicantName: '',
					start_date: '',
					end_date: '',
				},
				organizeIds_num: [],
				organize_id: [],
				photoList: [],
				tableDataList: {},

				multipleSelection: [],
				options: [{}],
				input: '',
				gwList: [],
				tableData: [],

				download_excel: {
					"组织架构": "organize_name",
				},

				//组织架构数据
				organizeList: [],
				partnerList: [],
				manageList: [],
				VoucherList: [],
				approveList: [],
				list: {},

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: false,
				},

			};
		},
		methods: {
			//组织架构选择
			changeCascader() {
				this.condition.organize_ids = this.organizeIds_num[this.organizeIds_num.length - 1];
				this.ruleForm.organize_id = this.organize_id[this.organize_id.length - 1];
			},
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach((item) => {
					this.ids.push(item.id);
				});
			},
			handleAvatarSuccess(res, file) {
				this.photoList.push({
					url: res.data.fileUrl
				})
				console.log(this.photoList)
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibles = true;
			},
			beforeremove(file, fileList) {
				this.photoList = fileList;
			},
			//分页
			handleCurrentChange(val) {
				this.condition.page_num = val;
				this.Find();
			},
			Add() {
				this.ruleForm = {};
				this.organize_id = [];
				this.showadd = true
			},
			async AddSave() {
				this.ruleForm.applicant_id = this.$globals.user.staff_id;
				var data = await this.$globals.AxiosPost('tenderBond/getTenderBondApproval', this.ruleForm);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableDataList = data;
						this.showadd = false;
						this.spShow = true;
					} else {
						this.$message.warning(data);
					}
				}

			},
			async AddSavesp() {
				var record = {
					partner_id: this.ruleForm.partner_id,
					organize_id: this.ruleForm.organize_id,
					project_name: this.ruleForm.project_name,
					money_amount: this.ruleForm.money_amount,
					estimate_payment_time: this.ruleForm.estimate_payment_time,
					spare: this.ruleForm.spare,
					id: this.ruleForm.id,
					applicant_id: this.ruleForm.applicant_id,
					approval: this.tableDataList
				}
				var data = await this.$globals.AxiosPost('tenderBond/add', record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.ruleForm = {};
						this.organize_id = [];
						this.showadd = false;
						this.spShow = false;
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},

			Revise(e) {
				this.ruleForm = e;
				this.showadd = true
			},
			async ReviseSave() {
				var data = await this.$globals.AxiosPost('tenderBond/update', this.ruleForm);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.ruleForm = {};
						this.showadd = false;
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},

			//查询
			async Find() {
				var record = {
					page_num: this.condition.page_num,
					page_size: this.condition.page_size,
					partner_id: this.condition.partner_id,
					start_date: this.condition.start_date != null && this.condition.start_date != '' ?
						this.condition.start_date[0] : '',
					end_date: this.condition.start_date != null && this.condition.start_date != '' ?
						this.condition.start_date[1] : '',
					organize_ids: this.condition.organize_ids,
					project_name: this.condition.project_name,
					applicantName: this.condition.applicantName,
				};
				var data = await this.$globals.AxiosPost('tenderBond/getList', record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},

			async Voucher(e) {
				var url = "tenderBond/getPhoto?tenderId=" + e;
				var data = await this.$globals.AxiosGet(url);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.VoucherList = data;
						this.showVoucher = true
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},

			async panelPoint(e) {
				var record = {
					manage_id: e.id,
					approval_type: 19
				}
				var data = await this.$globals.AxiosPost('OaMaAssociation/getExamineDetails', record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.approveList = data;
						if(this.approveList.length >0){
							this.showPoint = true;
						}
					} else {
						this.$message.warning(data);
					}
				}
			},
			async Update(e) {
				this.updatePhoto.id = e.id;
				this.updatePhoto.payment_time = '';
				this.photoList = [];
				var url = "tenderBond/getPhoto?tenderId=" + e.id;
				var data = await this.$globals.AxiosGet(url);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.VoucherList = data;
						this.updatePhoto.payment_time = data.payment_time;
						this.photoList = data.photoList;
						// if(this.VoucherList.photoList.length == 0){
						// 	this.Vouchers = 1
						// }
						this.showUpdate = true;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			async AddSavePhoto() {
				this.updatePhoto.photoList = [];
				this.photoList.forEach(item => {
					this.updatePhoto.photoList.push(item.url)
				})
				var data = await this.$globals.AxiosPost('tenderBond/updatePhoto', this.updatePhoto);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showUpdate = false;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			async Manage(e) {
				var url = "tenderBond/getTenderBond?tenderId=" + e;
				var data = await this.$globals.AxiosGet(url);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.manageList = data;

						this.Bond = false;
						this.showManage = true;

					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},

			closeManage() {
				this.Bond = true
				this.showManage = false
			},
			// 操作删除
			async Del(e) {
				var record = {
					ids: [e],
				};
				var data = await this.$globals.AxiosPost('tenderBond/del', record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			// 导表
			async ExportForm() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = 'staff/selectWholes';
				var record = {
					page_num: this.page_num,
					page_size: this.page_size,
					organize_ids: organize_ids,
					city_id: this.condition.city_id,
					post_id: this.condition.post_id,
					staff_name: this.condition.staff_name,
					start_date: this.condition.start_date != null && this.condition.start_date != '' ?
						this.condition.start_date[0] : '',
					end_date: this.condition.start_date != null && this.condition.start_date != '' ?
						this.condition.start_date[1] : '',
					formal_date: this.condition.formal_date,
					staff_card: this.condition.staff_card,
					induction_time: this.condition.induction_time,
					staff_telephone: this.condition.staff_telephone,
					is_formal: this.condition.is_formal,
					project_name: this.condition.project_name,
					modular_name: this.condition.modular_name,
					company_name: this.condition.company_name,
					post_name: this.condition.post_name,
					formal_salary: this.condition.formal_salary,
					id: this.condition.id,
					applicant_id: this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if (data.length > 0) {
							this.$message.success("导表成功！文件下载中！");
							return data;
						} else {
							this.$message.success("没有可以导出的数据！");
							return null;
						}

					} else {
						this.$message.warning(data);
					}
				}
			},

			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
				});
				this.organizeList = this.getTreeData(organizeList.data);

			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			},

			// 返回
			close(isFresh) {
				//isFresh是否需要刷新列表
				if (isFresh) this.Find();
				this.showadd = false;
			},
		},
		async created() {
			this.Find();
			this.organizeFind();
			// 岗位
			var gwList = await this.$globals.AxiosPost('post/selectFind', {});
			this.gwList = gwList.data;

			var partnerList = await this.$globals.AxiosPost("partner/selectFind", {});
			this.partnerList = partnerList.data;
		},
	};
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 100%;
		height: 300px;
		display: block;
	}
</style>
<style scoped>
	.el-aside {
		height: 700px;
		background-color: #fbfbfb;
	}

	.s {
		width: 260px;
		display: block;
		margin: 20px auto;
	}

	.bor {
		font-size: 20px;
	}

	.add {
		width: 90px;
		height: 35px;
		border-radius: 5px;
		color: #fff;
		background-color: #00724e;
	}

	.add2 {
		width: 90px;
		height: 35px;
		border-radius: 5px;
		color: #00724e;
		background-color: #fff;
		border: 1px solid #00724e;
	}

	.el-table {
		width: 850px;
		margin-top: 40px;
	}

	.el-pagination {
		width: 500px;
		text-align: center;
		margin-top: 30px;
	}

	.prev {
		width: 60px;
		height: 30px;
		position: absolute;
		top: 2px;
		left: 390px;
		color: #9094a0;
		background-color: #edf0f5;
		border: 0;
	}

	.ne {
		width: 60px;
		height: 30px;
		position: absolute;
		top: 2px;
		left: 460px;
		color: #9094a0;
		background-color: #edf0f5;
		border: 0;
	}

	.c {
		position: absolute;
		top: 1px;
		left: 560px;
	}

	.small {
		width: 50px;
		height: 20px;
	}

	.btn {
		width: 60px;
		height: 30px;
		position: absolute;
		background-color: #00724e;
		top: 5px;
		left: 680px;
		color: #fff;
		border-radius: 5px;
	}

	.input {
		width: 200px;
	}

	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.rz {
		margin-top: 20px;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 150px;
	}

	.el-dropdown /deep/ .el-button-group .el-button {
		width: 90px;
	}

	.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
		background-color: #00724e;
	}

	.el-table /deep/ thead {
		color: #000;
		font-weight: 700;
		background-color: #f0f0f0;
	}

	.bm {
		position: relative;
		height: 100px;
	}

	.el-button {
		background-color: #00724e;
		color: #fff;
		width: 100px;
	}

	.Time {
		margin-left: 80px;
	}

	.time {
		margin-bottom: 20px;
	}

	.money {
		margin-bottom: 50px;
	}

	.el-button--qian {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 13px;
		height: 40px;
		width: 80px;
	}

	.el-button--qian:focus,
	.el-button--qian:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}
	.approve {
		display: flex;
	}
	
	.approve-left {
		width: 16%;
		text-align: right;
	}
	
	.approve-img {
		width: 50px;
		height: 50px;
	}
	
	.approve-hr {
		border-right: 2px solid #C7DCF0;
		height: 40px;
		width: 1px;
		margin-left: 10%;
		margin-top: -5px;
	}
	
	.position {
		display: flex;
		justify-content: space-between;
		width: 78%;
		margin-left: 5px;
	}
	
	.position-left {
		display: flex;
		flex-direction: column;
		justify-content: center;
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
	}
	
	.position-refuse {
		width: 205%;
		line-height: 30px;
		font-size: 12px;
		font-weight: 400;
		padding-left: 10px;
		background: #F9F9F9;
	}
	
	.position-text {
		font-size: 13px;
		margin: 0 10px;
		color: #C1C1C1;
	}
	
	.blue {
		color: #3295FA;
	}
	
	.green {
		color: #14BB83;
	}
	
	.orange {
		color: #FD892C;
	}
	
	.red {
		color: #F05745;
	}
	.position-time {
		font-size: 13px;
		color: #C1C1C1;
		line-height: 26px;
	}
</style>



// WEBPACK FOOTER //
// Bond.vue?594ccf97